const CheckCircle = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_902_13359)">
<circle cx="8.00016" cy="7.99998" r="6.66667" stroke="currentColor"/>
<path d="M5.6665 8.33331L6.99984 9.66665L10.3332 6.33331" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_902_13359">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
  );
};

export default CheckCircle;